import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";
import WorkshopDataService from "../../services/Workshop";
import { useEffect, useState } from "react";
export const ParticipantsModal = ({ isOpen, onClose, id }: any) => {
  const [data, setData] = useState<any>([]);
  const [modalSize, setModalSize] = useState("4xl");
  const fetchData = () => {
    WorkshopDataService.getParticipants(id)
      .then((res: any) => {
        setData(res.data.data);

      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (isOpen) {
      const numRows = data.length;

      if (numRows === 0) {
        setModalSize("sm");
      } else {
        setModalSize("5xl");
      }
    }
  }, [isOpen, data]);

  return (
    <Modal size={modalSize} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Participants</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {data.length > 0 ? <div className="col-sm-12 card">
            <table className="table table-striped  mt-4">
              <thead>
                <tr>
                  <th style={{ width: "150px" }}>Uuid</th>
                  <th style={{ width: "150px" }}>Name</th>
                  <th style={{ width: "150px" }}>Email</th>
                  <th style={{ width: "150px" }}>Phone</th>
                </tr>
              </thead>
              <tbody>
                {data.map((el: any) => (
                  <tr key={el.uuid}>
                    <td style={{
                      maxWidth: "200px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}>{el.uuid}</td>
                    <td
                      style={{

                        minWidth: "150px",
                        maxWidth: "200px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {el.first_name} {el.last_name}
                    </td>
                    <td
                      style={{
                        minWidth: "150px",
                        maxWidth: "200px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {el.email ? el.email : "Not Available"}
                    </td>
                    <td style={{
                      maxWidth: "150px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}>{el.phone_number ? el.phone_number : "Not Available"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div> : "No Participants available."}
        </ModalBody>

        <ModalFooter>
          <Button bgColor="red" color={"white"} mr={3} onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
